import { render, staticRenderFns } from "./SharedGroupDetails.vue?vue&type=template&id=055a100f&scoped=true"
import script from "./SharedGroupDetails.vue?vue&type=script&lang=js"
export * from "./SharedGroupDetails.vue?vue&type=script&lang=js"
import style0 from "./SharedGroupDetails.vue?vue&type=style&index=0&id=055a100f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a100f",
  null
  
)

export default component.exports